import postData from '../assets/js/fetch.js'

let dev
process.env.NODE_ENV === 'production' ? (dev = '') : (dev = 'https://app.icnea.net')

const state = {
    deliveries: [],
    deliveriesCalendar: [],
    deliveryDetail: [],
    numIncidencia: '',
}

const mutations = {
    setDeliveries(state, deliveries) {
        state.deliveries = deliveries
    },
    setDeliveriesCalendar(state, deliveriesCalendar) {
        state.deliveriesCalendar = deliveriesCalendar
    },
    setDeliveryDetail(state, deliveryDetail) {
        state.deliveryDetail = deliveryDetail
    },
    setNumIncidencia(state, numIncidencia) {
        state.numIncidencia = numIncidencia
    },
}

const actions = {
    //// Cleaning ////
    getDeliveries({commit}, {usr, data}) {
        postData(dev + '/WebService.asmx/Repartiments', {usr, data}).then((data) => {
            let array = []

            console.log('RepartimentsRAW', data)

            // const test = {
            //   Response: {
            //     dates: [
            //       {
            //         date: '2025-07-13',
            //         deliveries: [
            //           {
            //             property: {lodging_id: '1016.1.0', lodging_name: 'A-Auri'},
            //             delivery: {
            //               delivery_id: '2686be49-abcc-4a6e-b87a-22c57d93a7ce',
            //               cleaning_status: 'pending',
            //               delivery_category: '',
            //               delivery_date: '2025-07-13',
            //               delivery_time: '2',
            //               delivery_remarks: 'hellooo, its meee',
            //               delivery_person: '',
            //             },
            //           },
            //         ],
            //       },
            //     ],
            //   },
            // }
            // test.Response.dates.forEach((delivery) => {

            JSON.parse(data.d).Response.dates.forEach((delivery) => {
                delivery.expanded = true
                array.push(delivery)
            })
            const deliveries = {dates: array}
            console.log('Repartiments', deliveries)

            commit('setDeliveries', deliveries)
        })
    },
    getDeliveriesCalendar({commit}, {usr, data}) {
        postData(dev + '/WebService.asmx/RepartimentsCalendari', {usr, data}).then((data) => {
            console.log('RepartimentsCalendari', JSON.parse(data.d).Response)
            commit('setDeliveriesCalendar', JSON.parse(data.d).Response)
        })
    },
    getDeliveryDetail({commit}, {usr, id, data}) {
        postData(dev + '/WebService.asmx/RepartimentsDetall', {usr, id, data}).then((data) => {
            console.log('RepartimentsDetall', data)
            console.log('RepartimentsDetall', JSON.parse(data.d).Response)
            commit('setDeliveryDetail', JSON.parse(data.d).Response)
        })
    },
    postCleaningStatus({dispatch}, {usr, id, final, fecha, lat, lng}) {
        console.log({usr, id, final, fecha, lat, lng})
        dispatch('', '')
        //   postData(dev + '/WebService.asmx/NetejesEstat', {
        //     usr,
        //     id,
        //     final,
        //     lat,
        //     lng,
        //   }).then((data) => {
        //     if (data.d == true) {
        //       dispatch('getCleaningDetail', {usr, id, data: fecha})
        //     }
        //   })
    },
    postIncidencia({commit}, {usr, lodging_id, titular, texte, motiu}) {
        console.log(usr, lodging_id, titular, texte, motiu)
        postData(dev + '/WebService.asmx/ServeiCrear', {
            usr,
            lodgingId: lodging_id,
            titular,
            texte,
            motiu,
        }).then((data) => {
            commit('setNumIncidencia', data.d)
        })
    },
    postNetejaEnviarFotos({dispatch}, {usr, id, data, image1, image2, image3, idUrl}) {
        const image4 = '',
            image5 = '',
            image6 = ''
        if (image1 == '' && image2 == '' && image3 == '') {
            dispatch('getCleaningDetail', {usr, id: idUrl, data})
        } else {
            postData(dev + '/WebService.asmx/ServeiImatge', {
                usr,
                id,
                image1,
                image2,
                image3,
                image4,
                image5,
                image6,
                data,
            }).then((datos) => {
                console.log('rawServeiImatge', datos)
                if (datos.d === true) {
                    dispatch('getCleaningDetail', {usr, id: idUrl, data})
                }
            })
        }
    },
    postNetejesChecklistConfirmar({dispatch}, {usr, cleaning_id, cleaning_instruction_id, data, lat, lng}) {
        console.log({usr, cleaning_id, cleaning_instruction_id, data, lat, lng})
        dispatch('', '')
        //   postData(dev + '/WebService.asmx/NetejesChecklistConfirmar', {
        //     usr,
        //     cleaning_id,
        //     cleaning_instruction_id,
        //     lat,
        //     lng,
        //   }).then((datos) => {
        //     if (datos.d === true) {
        //       dispatch('getCleaningDetail', {usr, id: cleaning_id, data})
        //     }
        //   })
    },
    postNetejesChecklistFoto({dispatch}, {usr, cleaning_id, cleaning_instruction_id, base64, data, lat, lng}) {
        console.log({
            usr,
            cleaning_id,
            cleaning_instruction_id,
            base64,
            data,
            lat,
            lng,
        })
        dispatch('', '')
        //   postData(dev + '/WebService.asmx/NetejesChecklistFoto', {
        //     usr,
        //     cleaning_id,
        //     cleaning_instruction_id,
        //     base64,
        //     lat,
        //     lng,
        //   }).then((datos) => {
        //     if (datos.d === true) {
        //       dispatch('getCleaningDetail', {usr, id: cleaning_id, data})
        //     }
        //   })
    },
    postNetejesObservacions({dispatch}, {usr, lodging_id, cleaning_service_remarks, id, datap}) {
        console.log({usr, lodging_id, cleaning_service_remarks, id, datap})
        dispatch('', '')
        //   postData(dev + '/WebService.asmx/NetejesObservacions', {
        //     usr,
        //     lodging_id,
        //     cleaning_service_remarks,
        //   }).then((data) => {
        //     console.log('NetejesObservacions', data.d)
        //     if (data.d === true) {
        //       console.log(usr, id, datap)
        //       dispatch('getCleaningDetail', {usr, id, data: datap})
        //     }
        //   })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
